import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getTakk } from "../services/takk";
import { getTakkToday } from "../services/takk-today";

export function useTakk() {
  return useQuery({
    queryKey: ["takk"],
    queryFn: () => getTakk(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useTakkToday(code?: string) {
  return useQuery({
    queryKey: ["takk-today", ...(code ? [code] : [])],
    queryFn: () => getTakkToday(code),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
